"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      roleForm: {},
      roleFormList: [{
        title: "系统管理员",
        roles: [{
          label: "是否查看作品所属大类：",
          radio: "1"
        }, {
          label: "是否允许查看报名表：",
          radio: "1"
        }, {
          label: "是否显示审核状态：",
          radio: "1"
        }, {
          label: "是否显示审核专家：",
          radio: "1"
        }, {
          label: "是否显示最终得分：",
          radio: "1"
        }]
      }, {
        title: "学校管理员",
        roles: [{
          label: "是否查看作品所属大类：",
          radioValue: "1",
          radio: "1"
        }, {
          label: "是否允许查看报名表：",
          radioValue: "",
          radio: "1"
        }, {
          label: "是否显示审核状态：",
          radioValue: "",
          radio: "1"
        }, {
          label: "是否显示审核专家：",
          radioValue: "",
          radio: "1"
        }, {
          label: "是否显示最终得分：",
          radioValue: "",
          radio: "1"
        }]
      }, {
        title: "专家",
        roles: [{
          label: "是否查看作品所属大类：",
          radioValue: "1",
          radio: "1"
        }, {
          label: "是否允许查看报名表：",
          radioValue: "",
          radio: "1"
        }, {
          label: "是否显示审核状态：",
          radioValue: "",
          radio: "1"
        }, {
          label: "是否显示审核专家：",
          radioValue: "",
          radio: "1"
        }, {
          label: "是否显示最终得分：",
          radioValue: "",
          radio: "1"
        }]
      }, {
        title: "选手",
        roles: [{
          label: "是否查看作品所属大类：",
          radioValue: "1",
          radio: "1"
        }, {
          label: "是否允许查看报名表：",
          radioValue: "",
          radio: "1"
        }, {
          label: "是否显示审核状态：",
          radioValue: "",
          radio: "1"
        }, {
          label: "是否显示审核专家：",
          radioValue: "",
          radio: "1"
        }, {
          label: "是否显示最终得分：",
          radioValue: "",
          radio: "1"
        }]
      }]
    };
  }
};